import classNames from "classnames/bind";
import styles from "./Setting.module.css";
import SideBarSetting from "./Sidebar/SideBarSetting";
import ConfigSpace from "./ConfigSpace";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

function Setting() {
    const [cameraCode, setCameraCode] = useState({
        code: null,
        name: null
    });
    const handleChangeCameraCode = (code, name) => {
        setCameraCode({
            code: code,
            name: name
        });
    }
    const { t } = useTranslation()
    return (
        <div className={cx("wrapper-setting")}>
            <div className={cx('side-bar')}>
                <SideBarSetting onChangeCamera={handleChangeCameraCode} cameraCode={cameraCode.code} />
            </div>
            <div className={cx('content')}>
                <div className={cx("header")}>
                    <h1 className={cx("title")}>{t("header.setupNotification")}</h1>
                    <h1 className={cx("camera-name")}>{cameraCode?.name || ''}</h1>
                </div>
                <ConfigSpace cameraInfo={cameraCode} />
            </div>
        </div>
    )
}

export default Setting;